import { render } from "./GrossProductSearch.vue?vue&type=template&id=8b94eb52&scoped=true"
import script from "./GrossProductSearch.vue?vue&type=script&lang=js"
export * from "./GrossProductSearch.vue?vue&type=script&lang=js"

import "./GrossProductSearch.vue?vue&type=style&index=0&id=8b94eb52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b94eb52"]])

export default __exports__